import gql from 'graphql-tag';

export const GET_SURROUNDING_INFORMATION_WITH_ALL_LOCALES = gql`
  fragment CommonSurroundingInformationProperty on SurroundingInformationProperty {
    id
    icon
    text
    badgeColor
    surroundingInformation {
      id
    }
    locale
    appSortOrder
  }

  fragment CommonSurroundingInformation on SurroundingInformation {
    id
    title
    bodyText
    bannerImage {
      id
      url
      formats
    }
    externalBannerImage
    locale
    website
    phoneNr
    locationLat
    locationLon
    locationName
    shortDescription
    hidden
    fusionarId
    email
    openingTimes
    disabledSynchronisationFields
    properties {
      ...CommonSurroundingInformationProperty
      localizations {
        ...CommonSurroundingInformationProperty
      }
    }
  }
  query GetSurroundingInformationWithAllLocales($id: ID!) {
    surroundingInformation(id: $id) {
      ...CommonSurroundingInformation
      localizations {
        ...CommonSurroundingInformation
      }
    }
  }
`;
